<template>
  <transition name="fade" :css="dismissible">
    <div class="p-alert" :class="[modifier, extraClass, {'disabled': disabled}]" v-if="visible">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex">
          <div class="p-alert__icon" v-if="icon">
            <CIcon :name="icon" size="custom-size" width="36" class="icon-circle" :class="'icon-circle--' + color"/>
          </div>
          <div class="p-alert__text align-self-center">
            <slot>
              <h6 v-if="title">{{ title }}</h6>
              <p v-html="text" v-if="text"></p>
            </slot>
          </div>
        </div>
        <div class="p-alert__cta">
          <slot name="cta"></slot>
        </div>
        <CButtonClose class="p-alert__close" @click="onDismiss" v-if="dismissible"/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PAlert",
  data() {
    return {
      visible: true
    }
  },
  props: {
    color: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    extraClass: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modifier() {
      return `p-alert--${this.color}`;
    }
  },
  methods: {
    onDismiss() {
      this.visible = false;
      this.$emit("dismiss");
    }
  }
}
</script>


<style scoped>

</style>